import React, {useEffect, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import style from "styled-components";
import Button from "@mui/material/Button";
import {styled} from "@mui/system";
import {useEthers} from "@usedapp/core";
import BigNumber from "bignumber.js";
import CardContentTitle from "../CardContentTitle";
import {
  enableSelectedContract,
  setIsEnableLoading,
  setIsDepositLoading,
  depositSelectedContract,
  getTotalAllowance,
} from "../../../store/stakingStore";
import {stakedTokenABI} from "../../../contracts/StakingTokenABI";

function InitialDeposit({stackingPool, setIsDeposit}) {
  const dispatch = useDispatch();
  const {account, library} = useEthers();
  const {totalAllowance, isEnableLoadingObj, isDepositLoadingObj} = useSelector(
    (state) => state.stakingSlice
  );
  const [isEnable, setIsEnable] = useState(false);
  const [value, setValue] = useState("");

  const enableSelectedPool = (stackingPool) => {
    const approveAmount = new BigNumber(2)
      .exponentiatedBy(new BigNumber(255))
      .minus(new BigNumber(1));
    dispatch(
      enableSelectedContract({
        stakedTokenABI,
        provider: library,
        approveAmount,
        account,
      })
    ).then((res) => {
      /* const allowanceObj = {
        account,
        stakedTokenAddress: stackingPool?.stakedToken,
      };
      dispatch(getTotalAllowance(allowanceObj)); */
    });
    const selectedObj = {
      id: stackingPool?.id,
      isFixed: stackingPool?.isFixed,
    };

    dispatch(setIsEnableLoading(selectedObj));
  };

  const depositSelectedPool = (stackingPool) => {
    const depositAmount = new BigNumber(value).multipliedBy(Math.pow(10, 9));
    const obj = {
      selectedPoolId: stackingPool?.id,
      amount: depositAmount.toString(10),
      isFixed: stackingPool?.isFixed,
      provider: library,
      account,
    };
    if (value > 0) {
      dispatch(depositSelectedContract(obj));
    } else {
      alert("Please fill the deposti amount");
    }

    const selectedObj = {
      id: stackingPool?.id,
      isFixed: stackingPool?.isFixed,
    };
    dispatch(setIsDepositLoading(selectedObj));
  };

  const handleChange = (event) => {
    const result = event.target.value.replace(/\D/g, "");

    setValue(result);
  };
  //console.log("totalAllowance", totalAllowance);

  return (
    <>
      <CardContainer>
        <CardContentTitle stackingPool={stackingPool} />

        <FlexCenterContainer>
          <InputContainer
            type="text"
            name="name"
            value={value}
            onChange={handleChange}
            disabled={!(totalAllowance > 0)}
            placeholder="Amount"
            isDisabled={!(totalAllowance > 0)}
          />
          {totalAllowance > 0 ? (
            <DepositButton
              variant="contained"
              onClick={() => depositSelectedPool(stackingPool)}
            >
              {isDepositLoadingObj?.id === stackingPool?.id &&
              isDepositLoadingObj?.isFixed === stackingPool?.isFixed &&
              isDepositLoadingObj.depositLoading
                ? "Processing..."
                : "Deposit"}
            </DepositButton>
          ) : (
            <DepositButton
              variant="contained"
              onClick={() => enableSelectedPool(stackingPool)}
            >
              {isEnableLoadingObj?.id === stackingPool?.id &&
              isEnableLoadingObj?.isFixed === stackingPool?.isFixed &&
              isEnableLoadingObj.enableLoading
                ? "Processing..."
                : "Enable"}
            </DepositButton>
          )}
        </FlexCenterContainer>
      </CardContainer>
    </>
  );
}

export default InitialDeposit;

const CardContainer = style.div`
padding:16px;
display:flex;
flex-direction:column;
justify-content:space-between;
`;

const FlexCenterContainer = style.div`
display:flex;
flex-direction: column;
align-items: center;
justify-content:center;
`;
const InputContainer = style.input`
  background-color:#0000004f
  ;
  width: 100%;
  margin: 5px;
  border: 2px solid #D7D7D7;
  border-radius: 20px;
  padding: 5px;
  color: #fdfdfd;
  text-align: center;
  cursor: ${(p) => (p.isDisabled ? "no-drop" : "auto")}
`;
const DepositButton = styled(Button)`
  width: 100%;
  padding: 8px;
  margin-top: 10px;
  border-radius: 10px;
  background: none;
  border-radius: 1.5rem;
  border: 2px solid rgb(0, 0, 0);
  box-shadow: rgb(0 0 0) 0px 0px 15px;
  background-color: rgba(0, 0, 0, 0.5);
  color: black;
  font-weight: bold;
  color: #fff;
  font-size: 1rem;
  &:hover {
    background-color: rgba(100, 20, 20, 0.35);
  }
`;
